import { Field, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { BaseEntity, generateEntityId } from '@ztechapps/common.contract'

@ObjectType()
export class GradeType extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('grade') })
  declare _id: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  fdaGrade?: string
}
